export default __webpack_public_path__ + "static/mobile-notifications-b643daee4012658d8f1e90e72a72b1ba.png";